<template>
  <draggable
    class="side-bar"
    v-model="items"
    handle=".handle"
    :group="{ name: 'dashboard-widgets', pull: true, put: true }"
    @start="onStart"
    @end="onEnd"
  >
    <template v-for="item in items">
      <template
        v-if="
          item.componentName &&
          item.componentName === 'alarms-widget' &&
          shouldShowWidget(item)
        "
      >
        <component
          :is="item.componentName"
          :title="resolveWidgetTitle(item.title)"
          :filters="item.filters"
          :id="item.id"
          :key="item.id"
          :collapsible="item.collapsible"
          :isOpen="item.isOpen"
          location="sideBar"
          @widget-collapsed="onWidgetCollapse"
        />
      </template>

      <template
        v-else-if="
          item.componentName &&
          item.componentName === 'tenants-widget' &&
          shouldShowWidget(item)
        "
      >
        <component
          :is="item.componentName"
          :title="resolveWidgetTitle(item.componentName)"
          :id="item.id"
          :key="`tenants-widget-${item.id}`"
          :collapsible="item.collapsible"
          :isOpen="item.isOpen"
          location="sideBar"
          @widget-collapsed="onWidgetCollapse"
        />
      </template>

      <template v-else-if="item.componentName && shouldShowWidget(item)">
        <component
          :is="item.componentName"
          :title="resolveWidgetTitle(item.componentName)"
          :id="item.id"
          :key="item.id"
          :collapsible="item.collapsible"
          :isOpen="item.isOpen"
          location="bottomBar"
          @widget-collapsed="onWidgetCollapse"
        />
      </template>
    </template>
  </draggable>
</template>

<script>
import store from "@/store";
import draggable from "vuedraggable";
import AlarmsWidget from "./widgets/AlarmsWidget";
import TenantsWidget from "./widgets/TenantsWidget";
import LayoutsWidget from "./widgets/LayoutsWidget";
import WidgetsWidget from "./widgets/WidgetsWidget";
import ViewsWidget from "./widgets/ViewsWidget/ViewsWidget.vue";
import VideoTourWidget from "./widgets/VideoTourWidget";
import ScriptsWidget from "./widgets/ScriptsWidget";
import VideoWallWidget from "./widgets/VideoWallWidget.vue";
import PagesWidget from "./widgets/PagesWidget";
import UnitGroupsWidget from "./widgets/UnitGroupsWidget";
import UserChartsWidget from "./widgets/UserChartsWidget";
import ChatWidget from "./widgets/ChatWidget";

export default {
  components: {
    draggable,
    AlarmsWidget,
    TenantsWidget,
    LayoutsWidget,
    WidgetsWidget,
    ViewsWidget,
    ScriptsWidget,
    VideoWallWidget,
    PagesWidget,
    UnitGroupsWidget,
    UserChartsWidget,
    ChatWidget,
    VideoTourWidget
  },
  data() {
    return {};
  },
  computed: {
    items: {
      get() {
        return store.state.grid.sideBarItems;
      },
      set(value) {
        store.dispatch("grid/setSideBarItems", value);
      },
    },
    user() {
      return store.getters["user/getUser"];
    }
  },

  mounted() {
    this.$watch(
      () => store.state.grid.sideBarItems,
      (newVal) => {
        console.log("sidebar items changed:", newVal);
        if (!newVal || newVal.length === 0) {
          store.commit("psimConfig/UPDATE_TOOLBARS_COLLAPSED", true);
        }
      },
      {deep: true}
    );
  },

  methods: {
    onStart(evt) {
      store.commit("grid/setSidebarStartDragging", true);
      evt.originalEvent.dataTransfer.setData("from", "left");
    },
    onEnd(evt) {
      store.commit("grid/setSidebarStartDragging", false);

      const from = evt.originalEvent.dataTransfer.getData("from");
      const to = evt.to !== evt.from ? "right" : "left";

      const movedElement = evt.item?._underlying_vm_ || evt.item?._underlying_vm || null;

      if (from === "left" && to === "right" && movedElement) {
        store.dispatch("grid/moveWidget", {
          widget: movedElement,
          from: "left",
          to: "right",
          newList: store.state.grid.sideBarRightItems
        });
        return;
      }

      store.dispatch("user/updateUserConfig");
    },

    onWidgetCollapse(data) {
      store.dispatch("grid/updateWidgetStatus", data);
    },

    shouldShowWidget(item) {
      switch (item.componentName) {
        case "alarms-widget":
          if (item.id == 1) {
            return this.$can("waiting_alarms", "Workspace");
          } else if (item.id == 2) {
            return this.$can("attending_alarms", "Workspace");
          } else if (item.id === "user_alarms") {
            return this.$can("user_alarms", "Workspace");
          } else if (item.id === "in_review_alarms") {
            return this.$can("in_review_alarms", "Workspace");
          } else if (item.id === "in_maintenance_alarms") {
            return this.$can("in_maintenance_alarms", "Workspace");
          } else {
            return false;
          }
        case "tenants-widget":
          return this.$can('facilities', 'Workspace');

        case "layouts-widget":
          return this.$can('layouts', 'Workspace');

        case "views-widget":
          return this.$can('views', 'Workspace');

        case "video-tour-widget":
          return this.$can('read', 'VideoTour');

        case "widgets-widget":
          return this.$can('widgets', 'Workspace');

        case "video-wall-widget":
          return this.$can('read', 'VideoWall');

        // case "scripts-widget":
        //   return this.$can('commands', 'Workspace');

        // case "pages-widget":
        //   return this.$can('web_pages', 'Workspace');

        // case "unit-groups-widget":
        //   return this.$can('facilities_group', 'Workspace');

        // case "user-charts-widget":
        //   return this.$can('charts', 'Workspace');

        case "chat-widget":
          if (this.user.enabled_chat && Number(window.__env.VUE_APP_ENABLED_CHAT)) {
            return this.$can('chat', 'Workspace');
          }
          return false;

        default:
          return false;
      }
    },
    resolveWidgetTitle(title) {
      switch (title) {
        case "Alarmas en espera":
          return window.__env.VUE_APP_ENV == "banamex" ? "Alarmas por atender" : this.$t("grid.widgets.alarms.incoming_alarms.title");

        case "Alarmas en atención":
          return window.__env.VUE_APP_ENV == "banamex" ? "Alarmas en espera" : this.$t("grid.widgets.alarms.alarms_being_attended.title");

        case "Alarmas de usuario":
          return "Alarma en atención";

        case "Alarmas en revisión":
          return window.__env.VUE_APP_ENV == "banamex" ? "Maker Checker" : "Alarmas en revisión";

        case "tenants-widget":
          return this.$t("grid.widgets.units.title");

        case "layouts-widget":
          return this.$t("grid.widgets.layouts.title");

        case "views-widget":
          return this.$t("grid.widgets.views.title");

        case "video-tour-widget":
          return "Video Tour";

        case "widgets-widget":
          return this.$t("grid.widgets.widgets.title");

        case "video-wall-widget":
          return this.$t("grid.widgets.videowall.title");

        case "scripts-widget":
          return this.$t("grid.widgets.scripts.title");

        case "pages-widget":
          return this.$tc("pages.title", 2);

        case "unit-groups-widget":
          return this.$t("unit_groups.title");

        case "user-charts-widget":
          return this.$t("grid.widgets.charts.title");

        case "chat-widget":
          return "Chat";

        default:
          return title;
      }
    }
  },
};
</script>
